var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.3337C14.6024 18.3337 18.3333 14.6027 18.3333 10.0003C18.3333 5.39795 14.6024 1.66699 10 1.66699C5.39762 1.66699 1.66666 5.39795 1.66666 10.0003C1.66666 14.6027 5.39762 18.3337 10 18.3337Z",
    fill: "#52B3A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9741 6.51474C14.2882 6.17828 14.8155 6.1601 15.1519 6.47412C15.4884 6.78815 15.5066 7.31548 15.1926 7.65194L9.35923 13.9019C9.05455 14.2284 8.54672 14.2566 8.20769 13.9661L5.29102 11.4661C4.94158 11.1665 4.90112 10.6404 5.20063 10.291C5.50015 9.94157 6.02624 9.9011 6.37567 10.2006L8.68584 12.1808L13.9741 6.51474Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneCircle);
export default __webpack_public_path__ + "static/media/done-circle.e0172e7888d938d3c29ab8ee83e44401.svg";
export { ForwardRef as ReactComponent };